<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row v-if="( [18,19].includes( getdatosUsuarioERPERP.idpuesto ) && [568, 7, 161, 626, 382, 1258, 1457, 1659, 1673, 1944 ].includes( getdatosUsuarioERPERP.iderp ) ) || ![18,19].includes( getdatosUsuarioERPERP.idpuesto )">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Entrevistas</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( filterEntrevistas  , 'ENTREVISTAS')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
              <!-- <v-col cols="12" md="3">
	  		  			<v-text-field label="Fecha Inicial" type="date" filled dense hide-details v-model="filtroFechaIni"></v-text-field>
	  		  		</v-col>
              <v-col cols="12" md="3">
	  		  			<v-text-field label="Fecha Final" type="date" filled dense hide-details v-model="filtroFechaFin"></v-text-field>
	  		  		</v-col> -->

              <v-col cols="12" md="6" lg="3">
                <v-autocomplete
                  :items="planteles"
                  item-text="plantel"
                  item-value="id_plantel"
                  v-model="id_plantel"
                  label="Plantel"
                  clearable
                  filled
                  dense
                  hide-details
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <v-autocomplete label="Estatus" filled dense clearable hide-details :items="estatus" item-value="id_estatus" v-model="filtroEstatus"></v-autocomplete>
              </v-col>
	  		  		<v-col cols="12" md="3">
                
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="filterEntrevistas"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >

                  <!-- Modo llegó  -->
                  <template v-slot:item.modo_llego="{ item }">
                    <v-chip v-if="item.modo_llego == 1" small  dark >Indeed</v-chip>
                    <v-chip v-if="item.modo_llego == 2" small dark>Facebook</v-chip>
                  </template>

                  <!-- Modo llegó  -->
                  <template v-slot:item.vistobueno="{ item }">
                    <v-chip v-if="!item.vistobueno"     small dark color="grey">Pendiente</v-chip>
                    <v-chip v-if="item.vistobueno == 1" small dark color="green">Visto bueno</v-chip>
                    <v-chip v-if="item.vistobueno == 2" small dark color="black">Rechazado</v-chip>
                  </template>

                  <!-- Modo llegó  -->
                  <template v-slot:item.asistio="{ item }">
                    <v-checkbox 
                      v-model="item.asistio" 
                      :value="1"
                      readonly
                    ></v-checkbox>
                  </template>

							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>

							    <template v-slot:item.estatus="{ item }">
							    	<v-chip color="green"        small dark v-if="item.estatus == 1">Aplica</v-chip>
							    	<v-chip color="red"          small dark v-if="item.estatus == 2">No Aplica</v-chip>
							    	<v-chip color="red darken-3" small dark v-if="item.estatus == 3">No se presentó</v-chip>
							    	<v-chip color="yellow"       small      v-if="item.estatus == 4">Segunda Entrevista</v-chip>
                    <v-chip color="orange"       small      v-if="item.estatus == 5">Citado para training</v-chip>
                    <v-chip color="pink"         small      v-if="item.estatus == 6">Abandonó proceso</v-chip>
                    <v-chip color="blue"         small      v-if="item.estatus == 7">En proceso</v-chip>
							    	<v-chip color="cyan "        small      v-if="item.estatus == 8">Contratada</v-chip>
							    </template>
							  
							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small

							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.identrevistas }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-tabs
            v-model="tab"
            align-with-title
          >
            <v-tabs-slider></v-tabs-slider>

            <v-tab>General</v-tab>
            <v-tab>Archivos</v-tab>
            <v-tab>Visto bueno</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">

            <!-- Nómina administrativa -->
            <v-tab-item>

              <v-row>
              	<v-col cols="12">
                  <v-text-field
                    v-model="editedItem.nombre"
                    label="Nombre"
                    filled
                    hide-details
                    dense
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.telefono"
                    label="Teléfono"
                    filled
                    hide-details
                    dense
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-autocomplete
                    :items="vacantes"
                    v-model="editedItem.idseguimiento_campanias"
                    label="Vacante"
                    clearable
                    filled
                    dense
                    item-text="vacante"
                    item-value="idseguimiento_campanias"
                    hide-details
                    readonly
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" md="6">
                  <v-autocomplete
                    label="Zona"
                    id="id"
                    filled
                    dense
                    hide-details
                    v-model="editedItem.id_zona"
                    :items="planteles"
                    item-text="plantel"
                    item-value="id_plantel"
                    clearable
                    hide-details
                    readonly
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.fecha_cita"
                    label="Cita"
                    filled
                    type="date"
                    hide-details
                    dense
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.hora_cita"
                    label="Hora"
                    filled
                    type="time"
                    hide-details
                    dense
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-autocomplete
                    label="Lugar de entrevista"
                    id="id"
                    filled
                    dense
                    hide-details
                    v-model="editedItem.id_lugar"
                    :items="planteles"
                    item-text="plantel"
                    item-value="id_plantel"
                    clearable
                    hide-details
                    readonly
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                	<v-autocomplete
                    filled
                    dense
                    clearable
                    v-model="editedItem.id_responsable"
                    :items="usuarios"
                    label="Responsable"
                    persistent-hint
                    prepend-inner-icon="mdi-account"
                    hide-details
                    item-text="nombre_completo"
                    item-value="id_usuario"
                    readonly
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                	<v-autocomplete
                    filled
                    dense
                    clearable
                    v-model="editedItem.id_entrevistador"
                    :items="usuarios"
                    label="Entrevistador"
                    persistent-hint
                    prepend-inner-icon="mdi-account"
                    hide-details
                    item-text="nombre_completo"
                    item-value="id_usuario"
                    readonly
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.notas"
                    label="Notas"
                    filled
                    rows="3"
                    auto-grow
                    hide-details
                    dense
                    readonly
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="6" v-if="editedItem.id_puesto == 10">
                  <v-text-field
                    v-model="editedItem.fecha_training"
                    label="Frecha training"
                    filled
                    type="date"
                    hide-details
                    dense
                    readonly
                  ></v-text-field>
                </v-col>



                <v-col cols="12" sm="6" class="pt-0">
                	<v-autocomplete
                    filled
                    dense
                    v-model="editedItem.estatus"
                    :items="estatus"
                    label="Estatus"
                    hide-details
                    item-text="text"
                    item-value="id_estatus"
                    readonly
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" class="pt-0">
                	<v-radio-group v-model="editedItem.modo_llego" small dense hide-details readonly>
                    <v-radio label="Indeed" :value="1"></v-radio>
                    <v-radio label="Facebook" :value="2"></v-radio>
                  </v-radio-group>
                </v-col>

              </v-row>
            </v-tab-item>

            <v-tab-item>

              <v-row>
                <v-col cols="12">
                  <v-card class="pa-4">
                    <label>Documentos cargados</label>
                    <v-row dense>
                      <v-col
                        v-for="(file, index) in editedItem.documentos"
                        :key="index"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                      >
                        <v-card class="pa-2" elevation="3">
                          <v-btn
                            icon
                            color="red"
                            class="ma-0 pa-0 float-right"
                            small
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>

                          <div v-if="['png','jpg','JPG','PNG','webp'].includes(file.extension )">
                            <v-img :src="url + file.url_file" aspect-ratio="1" class="rounded"></v-img>
                          </div>

                          <div v-else-if="['mp4'].includes(file.extension )">
                            <video :src="url + file.url_file" controls style="width: 100%; border-radius: 8px;"></video>
                          </div>

                          <div v-else-if="['pdf','PDF'].includes(file.extension )">
                            <iframe :src="url + file.url_file" width="100%" height="200" style="border: none;"></iframe>
                          </div>

                          <div v-else class="text-center">
                            <v-icon large color="grey">mdi-file-document</v-icon>
                            <p class="caption mt-2">{{ file.url_file }}</p>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>

              <v-row>
                <v-col cols="12">
                  <v-card class="pa-4">
                    <v-row>
                      <v-col cols="12">
                        <v-radio-group
                          v-model="editedItem.vistobueno"
                          row
                        >
                          <v-radio
                            label="Visto Bueno"
                            :value="1"
                          ></v-radio>
                          <v-radio
                            label="Rechazado"
                            :value="2"
                          ></v-radio>
                        </v-radio-group>

                        <v-textarea
                          v-model="editedItem.comentario"
                          :rows="3"
                          auto-grow
                          label="Comentarios"
                        >
                        </v-textarea>

                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn
                        color="black"
                        tile
                        dark
                        small
                        @click="close"
                      >
                        <v-icon small left>mdi-cancel</v-icon>
                        Cancelar
                      </v-btn>

                      <v-spacer></v-spacer>
                      <v-btn 
                        color="success"
                        tile
                        dark
                        small
                        @click="saveVistoBueno( ) "
                      >
                        <v-icon small left>mdi-content-save</v-icon>
                        Guardar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-card-actions v-if="tab == 0">
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>

        <v-card-actions v-if="tab == 1">
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="dialogReporte" 
      max-width="500px"
    >
      <v-card>
        <v-card-title primary-title>
          Reporte de entrevistas
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headersReporte"
                :items="reporte"
                class="elevation-0"
                :search="search"
                :mobile-breakpoint="100"
                dense
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            color="black" 
            tile 
            dark 
            small
            @click="dialogReporte = false"
          >
            Cancelar
            <v-icon right small>mdi-cancel</v-icon>
          </v-btn>
        </v-card-actions>         
      </v-card>
    </v-dialog>


    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      url:'',

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        identrevistas: 0,
				nombre: null,
				telefono: null,
				id_puesto: null,
				id_zona: null,
				fecha_cita: null,
				hora_cita: null,
				id_responsable: null,
				id_lugar: null,
				estatus: null,
				notas: null,
				id_entrevistador:null,
				fecha_training: null,
        modo_llego: null,
        idseguimiento_campanias: 0,
        asisitio: 0,
      },

      defaultItem: {
        identrevistas: 0,
				nombre: null,
				telefono: null,
				id_puesto: null,
				id_zona: null,
				fecha_cita: null,
				hora_cita: null,
				id_responsable: null,
				id_lugar: null,
				estatus: null,
				notas: null,
				id_entrevistador:null,
				fecha_training: null,
        modo_llego: null,
        idseguimiento_campanias: 0,
        asisitio: 0,
      },

      // Filtros: 
      incio:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fin  :(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      salones: [],
      headers: [
        { text: 'ID'             , value: 'identrevistas'    },
        { text: 'Nombre  '       , value: 'nombre'           },
        { text: 'Teléfono'       , value: 'telefono'         },
        { text: 'Puesto'         , value: 'puesto'           },
        { text: 'Sucursal'       , value: 'zona'             },
        { text: 'Cita'           , value: 'fecha_cita'       },
        { text: 'Hora'           , value: 'hora_cita'        },
        { text: 'Responsable'    , value: 'responsable'      },
        { text: 'Entrevistador'  , value: 'entrevistador'    },
        { text: 'Lugar'          , value: 'lugar'            },
        { text: 'Estatus'        , value: 'estatus'          },
        { text: 'Llegó'          , value: 'modo_llego'       },
        { text: 'Asistió'        , value: 'asistio'          },
        { text: 'Fecha training' , value: 'fecha_training'   },
        { text: 'Visto Bueno'    , value: 'vistobueno'       },
        { text: 'Actions'        , value: 'actions', sortable: false },
      ],
      tab: null,
      entrevistas: [],
      puestos: [],
      usuarios:[],
      planteles:[],
      estatus: [
      	{ id_estatus: 1, text: 'Aplica'	              },
      	{ id_estatus: 2, text: 'No Aplica'	          },
      	{ id_estatus: 3, text: 'No se presentó'	      },
      	{ id_estatus: 4, text: 'Segunda entrevista'	  },
        { id_estatus: 5, text: 'Citado para training' },
        { id_estatus: 6, text: 'Abandonó proceso'     },
        { id_estatus: 7, text: 'En proceso'           },
      	{ id_estatus: 8, text: 'Contratada'         	},
      ],
      filtroEstatus: 0,
      filtroFechaIni: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      filtroFechaFin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dialogReporte: false,

      headersReporte:[
        { text: 'Puesto'     , value: 'puesto'      },
        { text: 'Sucursal'   , value: 'plantel'     },
        { text: 'Cantidad'   , value: 'cantidad'    },
      ],
      vacantes:[],
      id_plantel: null,
      files: [],
      previews: [],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar entrevista' : 'Editar entrevista'
      },

      filterEntrevistas(){
        let newEntrevistas = this.entrevistas
        if(this.filtroEstatus){
          if(this.filtroEstatus == 0){ newEntrevistas = newEntrevistas }
          if(this.filtroEstatus == 1){ newEntrevistas = newEntrevistas.filter( el=>el.estatus == 1) }
          if(this.filtroEstatus == 2){ newEntrevistas = newEntrevistas.filter( el=>el.estatus == 2) }
          if(this.filtroEstatus == 3){ newEntrevistas = newEntrevistas.filter( el=>el.estatus == 3) }
          if(this.filtroEstatus == 4){ newEntrevistas = newEntrevistas.filter( el=>el.estatus == 4) }
          if(this.filtroEstatus == 5){ newEntrevistas = newEntrevistas.filter( el=>el.estatus == 5) }
        }
        // if(this.filtroFechaIni && this.filtroFechaFin){
        //   if(this.filtroFechaIni > this.filtroFechaFin){
        //     this.validarErrorDirecto('Ingresar rango de fechas valido')
        //   } else {
        //     newEntrevistas = newEntrevistas.filter( el=>el.fecha_cita >= this.filtroFechaIni &&  el.fecha_cita <= this.filtroFechaFin)
        //   }
        // }

        if( this.id_plantel ){

          newEntrevistas = newEntrevistas.filter( el => el.id_zona == this.id_plantel )
          
        }



        return newEntrevistas
      },


      reporte( ){

        let data = this.filterEntrevistas

        let puestosDobles = this.filterEntrevistas.map((registro) => { return { puesto: registro.puesto, plantel: registro.zona  }})

        let puestos = Array.from(new Set(puestosDobles.map(JSON.stringify))).map(JSON.parse);


        for( const i in puestos ){

          const { puesto, plantel } = puestos[i]

          puestos[i]['cantidad'] = data.filter( el => el.zona == plantel && el.puesto == puesto ).length

        }

        return puestos
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      this.url = axios.defaults.baseURL + 'fotos-egresos/'
      await this.initialize()
      await this.getUsuarios()
      await this.getPlanteles()
      await this.getPuestos()
      await this.getVacantes()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.entrevistas = []
        return this.$http.post('entrevistas.list.jefe', this.getdatosUsuarioERPERP ).then(response=>{
        	this.entrevistas = response.data

        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios( ){
        this.cargar = true
        this.usuarios = []
        this.$http.get('usuarios.all.erp').then(response=>{
          this.usuarios = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{

          if( [1457,1258,1659].includes( this.getdatosUsuarioERPERP.iderp ) ){
        	 this.planteles = response.data.filter( el => [25,26,27,28,29,31].includes( el.id_plantel ))
          }else{
           this.planteles = response.data
          }
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPuestos () {
        this.puestos = []
        this.$http.get('puestos.all').then(response=>{
          this.cargar = false
          this.puestos = response.data
          // Traer los puestos
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getVacantes () {
        this.cargar = true
        this.vacantes = []
        
        const payload = {
          fechaini: this.filtroFechaIni,
          fechafin: this.filtroFechaFin
        }

        return this.$http.post('seguimiento.vacantes', payload ).then(response=>{
          this.vacantes = response.data.filter( el=> el.estatus == 1 )
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.entrevistas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // this.editedItem.fecha_training = this.editedItem.fecha_training ? this.editedItem.fecha_training.substr(10,0) : null 
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.entrevistas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1

        this.$http.put('entrevistas.update/' + this.editedItem.identrevistas, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	if(!this.editedItem.idseguimiento_campanias){
      		return this.validarErrorDirecto('Favor de llenar todos los campos')
      	}
      	// Cargamos al usuario que hizo el cambio
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('entrevistas.update/' + this.editedItem.identrevistas, this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
          	this.initialize()
        		this.close()
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('entrevistas.add', this.editedItem).then(response=>{
          	this.initialize()
        		this.close()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error.response.data.message )
        	}).finally( () => { this.cargar = false })
        }
      },


      updateEntrevista( item ){
        this.cargar = true

        this.$http.put('entrevistas.update/' + item.identrevistas, item).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      onFileChange(fileList) {
        this.previews = [];

        for (const file of fileList) {
          const url = URL.createObjectURL(file);
          this.previews.push({
            name: file.name,
            type: file.type,
            url,
            file: file
          });
        }
      },

      removeFile(index) {
        this.previews.splice(index, 1);
        this.files.splice(index, 1);
      },

      async saveFiles( ){

        let formData = new FormData();

        for( const i in this.previews ){

          const { file } = this.previews[i]

          // //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file',file);

        }

        // Agregar 
        formData.append('identrevistas', this.editedItem.identrevistas );


        try{
          
          const addArchivos = await this.$http.post('entrevistas.files', formData )

          this.validarSuccess('Datos cargados correctamente')

          this.editedItem['documentos'] = this.previews

          this.previews = []
          this.files    = []

          this.initialize( )

        }catch( error ){

          this.validarError( error.response.data.message )


        }
        

      },


      async saveVistoBueno( ){


        try{
          
          const addArchivos = await this.$http.post('entrevistas.vistobueno', this.editedItem )

          this.initialize( )

        }catch( error ){

          this.validarError( error.response.data.message )


        }
      }
    },
  }
</script>


<style scoped>
  .float-right {
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 2;
  }
</style>